import { Controller } from "../../lib/stimulus-shim"

/**
 * front--webmcp-help controller
 *
 * Enregistre les tools WebMCP Help Center depuis le <script id="mcp-context">.
 * Feature-detected : ne fait rien si navigator.modelContext n'existe pas.
 */
export default class extends Controller {
  connect() {
    if (!navigator.modelContext) return

    this._registeredToolNames = []
    this.contextData = this._readInlineContext()
    if (!this.contextData) return

    this._registerTools()
  }

  disconnect() {
    if (navigator.modelContext) {
      this._registeredToolNames.forEach(name => {
        try { navigator.modelContext.unregisterTool?.(name) } catch (e) {}
      })
    }
    this._registeredToolNames = []
  }

  _readInlineContext() {
    const el = document.getElementById("mcp-context")
    if (!el) return null

    try {
      return JSON.parse(el.textContent)
    } catch (e) {
      console.warn("[WebMCP Help] Failed to parse inline context:", e)
      return null
    }
  }

  _registerTools() {
    const ctx = this.contextData
    const tools = (ctx.tools || []).map(toolDef => ({
      name: toolDef.name,
      description: toolDef.description,
      inputSchema: toolDef.inputSchema || { type: "object", properties: {}, required: [] },
      annotations: toolDef.annotations || { readOnlyHint: true },
      execute: async (input) => {
        const url = new URL(toolDef._endpoint, window.location.origin)

        // Map input params to query string
        if (input) {
          Object.entries(input).forEach(([key, value]) => {
            if (url.pathname.includes(`:${key}`)) {
              url.pathname = url.pathname.replace(`:${key}`, encodeURIComponent(value))
            } else {
              url.searchParams.set(key, value)
            }
          })
        }

        const response = await fetch(url.toString())
        return response.json()
      }
    }))

    try {
      tools.forEach(tool => {
        navigator.modelContext.registerTool(tool)
        this._registeredToolNames.push(tool.name)
      })
    } catch (e) {
      console.warn("[WebMCP Help] Failed to register tools:", e)
    }
  }
}
